const SearchFillIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65332 15.75C12.5883 15.75 15.7783 12.56 15.7783 8.625C15.7783 4.68997 12.5883 1.5 8.65332 1.5C4.71829 1.5 1.52832 4.68997 1.52832 8.625C1.52832 12.56 4.71829 15.75 8.65332 15.75Z"
        fill="currentColor"
      />
      <path
        d="M16.0032 16.4999C15.8682 16.4999 15.7332 16.4474 15.6357 16.3499L14.2407 14.9549C14.0382 14.7524 14.0382 14.4224 14.2407 14.2124C14.4432 14.0099 14.7732 14.0099 14.9832 14.2124L16.3782 15.6074C16.5807 15.8099 16.5807 16.1399 16.3782 16.3499C16.2732 16.4474 16.1382 16.4999 16.0032 16.4999Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SearchFillIcon
